<template>
  <div class="live-commentary-broadcast">
    <p class="live-commentary-broadcast-icon">
      !
    </p>
    <div class="live-commentary-broadcast-info">
      <VBroadcast :list="broadcastList" />
    </div>
  </div>
</template>

<script>
import { VBroadcast } from 'fe-vui/async'

export default {
  name: 'Broadcast',
  components: {
    VBroadcast
  },
  data() {
    return {
      broadcastList: [
        {
          text: 'Sorry, due to some reasons, the live commentary is temporarily suspended, please be patient.'
        }
      ]
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.live-commentary-broadcast {
  position: absolute;
  z-index: 9;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 36/@rem;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  padding-left: 9/@rem;
  background-color: #ffefbf;

  &-icon {
    display: flex;
    width: 18/@rem;
    height: 18/@rem;
    align-items: center;
    justify-content: center;
    border: 1px solid #b2621b;
    border-radius: 24/@rem;
    color: #b2621b;
    font-size: 12/@rem;
    font-weight: bold;
  }

  &-info {
    flex: 1;
  }
}
</style>
